module.exports = __webpack_public_path__ + "static/media/white-heart.14b06d09.svg";